export function getCenterGroupUrlAndComponentPart(can, route, store) {
  let id = (route.params.id || store.state.user.primaryCenter.id).toString();
  let url = "/api/internal/groups/" + id;
  if (can("manage_dermicus") && route.path.includes("admin")) {
    return {
      url: url,
      adminType: "Admin",
    };
  } else if (can("manage_region") && route.path.includes("region")) {
    return {
      url: url,
      adminType: "Region",
    };
  } else {
    return {
      url: url,
      adminType: "",
    };
  }
}
